export function HomepageEvents() {
    if ($('body').hasClass('Home')) {

        $('.logo').slideUp(0);

        var mutationObserver = new MutationObserver(mutations => { mutationObserverEvent(mutations) });

        var mutationObserverEvent = (mutations: MutationRecord[]) => {
           // console.log(mutations);
            mutations.forEach((mutation: MutationRecord) => {
                if ($(mutation.target).hasClass('d-none')) {
                    $('.logo').fadeIn(500);
                    mutationObserver.disconnect();
                }
            });
        };

        mutationObserver.observe(document.getElementsByClassName('hero-banner')[0],
            {
                attributes: true,
                characterData: true,
                childList: true,
                subtree: true,
                attributeOldValue: true,
                characterDataOldValue: true
            });
    }
}